import { useState } from "react";
import { FlaskConical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useApi } from "@/components/common";
import { useT } from "@/i18n";

export function CompoundedPicker({ onPick, onClose }) {
  const { t } = useT();
  const [q, setQ] = useState("");
  const d = useApi(`/pharmacy/compounding/pos/released?q=${encodeURIComponent(q)}`, [q]);
  return <Dialog open onOpenChange={onClose}><DialogContent className="bg-card max-w-2xl" data-testid="cmp-picker">
    <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><FlaskConical className="h-4 w-4" />{t("pos.cmp.title")}</DialogTitle></DialogHeader>
    <Input autoFocus data-testid="cmp-picker-search" placeholder={t("pos.cmp.search")} value={q} onChange={(e) => setQ(e.target.value)} />
    <div className="max-h-[50vh] overflow-y-auto divide-y text-xs">
      {(d.data?.items || []).map((o) => <button key={o.id} className="w-full text-left py-2 flex justify-between items-center hover:bg-secondary px-1" data-testid={`cmp-pick-${o.id}`} onClick={() => onPick({ ...o, service_product_id: d.data.service_product_id, tax_rate: d.data.tax_rate })}>
        <span><span className="font-mono">{o.ref}</span> · {o.name} · {o.qty} {o.unit}<div className="text-muted-foreground">{o.patient_name || "—"} {o.prescription_ref ? `· Rx ${o.prescription_ref}` : ""} · {t("pos.cmp.bud")} {o.bud_date} · {o.batch_no}</div></span>
        <span className="font-mono whitespace-nowrap">€{o.suggested_price.toFixed(2)}</span></button>)}
      {d.data?.items?.length === 0 && <div className="py-6 text-center text-muted-foreground">{t("pos.cmp.none")}</div>}
    </div>
    <div className="text-[11px] text-muted-foreground">{t("pos.cmp.hint")}</div>
  </DialogContent></Dialog>;
}
